var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-translate';
import { Button, Glyphicon } from 'react-bootstrap';
import { actions as articleActions } from '../redux/articles';
import { provideMapState, VectorLayer } from 'react-openlayers';
import Article from '../components/Article';
import ArticleAdditionalColumn from '../components/ArticleAdditionalColumn';
import { getArticleThumb, getThemeDataColumnsAsObject, formatColumnValue } from '../utils/article';
import { getSource, getFeatureStyle } from '../utils/knreise';
import { ensureArticleModuleConfig } from '../hocs/ensureArticleModuleConfig';
import './ArticleWindow.scss';
import LoadingIndicator from '../components/LoadingIndicator';

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return bindActionCreators(Object.assign({}, articleActions), dispatch);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    articles: state.articles.articles,
    articleId: state.articles.articleId,
    articleLoading: state.articles.articleLoading,
    articleError: state.articles.articleError
  };
};

export var ArticleWindow = function (_React$Component) {
  _inherits(ArticleWindow, _React$Component);

  function ArticleWindow() {
    _classCallCheck(this, ArticleWindow);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  ArticleWindow.prototype.componentDidMount = function componentDidMount() {
    this.checkArticle(this.props);
  };

  ArticleWindow.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.checkArticle(nextProps);
  };

  ArticleWindow.prototype.componentWillUnmount = function componentWillUnmount() {
    this.props.resetLoadState();
  };

  ArticleWindow.prototype.highlightArticle = function highlightArticle(article) {
    var _props = this.props,
        maxZoom = _props.maxZoom,
        fitViewAndZoom = _props.fitViewAndZoom,
        disableZoom = _props.disableZoom;

    if (article && article.olFeature && article.id !== this.lastZoomedArticle) {
      this.lastZoomedArticle = article.id;
      var padding = [0, 0, 0, 0];
      var geometry = article.extent ? article.extent : article.olFeature.getGeometry(); // If window is on right side, offset center

      if (window.innerWidth > 768) {
        padding[1] = 350;
      }

      !disableZoom && setTimeout(function () {
        fitViewAndZoom(geometry, maxZoom);
      }, 250);
    }
  };

  ArticleWindow.prototype.checkArticle = function checkArticle(props) {
    var id = props.id,
        projCode = props.projCode,
        articleId = props.articleId,
        articleError = props.articleError,
        articleLoading = props.articleLoading,
        articles = props.articles,
        loadArticle = props.loadArticle;

    if (!articles[id]) {
      if (articleId !== id || !articleLoading && !articleError) {
        loadArticle(id, projCode);
      }

      return;
    }

    this.highlightArticle(articles[id]);
  };

  ArticleWindow.prototype.renderArticle = function renderArticle(article, source) {
    if (source && source.sourceName === 'Flickr') {
      article.properties.link = 'https://www.flickr.com/photos/' + article.properties.owner + '/' + article.properties.id;
    } else if (source && source.text === 'Vimeo') {
      article.properties.link = 'https://www.vimeo.com/' + article.vimeoData.video_id;
    }

    var _props2 = this.props,
        t = _props2.t,
        articleLoading = _props2.articleLoading,
        articleError = _props2.articleError;
    var ArticleComponent = this.props.articleComponent || Article;
    var ArticleAdditionalColumnComponent = this.props.additionalColumnComponent || ArticleAdditionalColumn;

    if (articleLoading) {
      return React.createElement('div', {
        className: 'loadOverlay'
      }, React.createElement(LoadingIndicator, null), t('Loading'));
    }

    if ((articleError || !article) && !articleLoading) {
      return React.createElement('div', {
        className: 'error'
      }, t('LoadError'));
    }

    var props = {};

    if (source && (source.value.api === 'avdigitheme' || source.value.api === 'avtheme')) {
      if (!source.colObject) {
        source.colObject = getThemeDataColumnsAsObject(source);
      }

      Object.keys(article.properties).forEach(function (key) {
        if (source.colObject[key]) {
          props[key] = formatColumnValue(article.properties[key], source.colObject[key].value_formatter, source.colObject[key].data_type, t('locale'));
        } else {
          // TODO, map and format content/title
          props[key] = article.properties[key];
        }
      });
    } else {
      props = article.properties;
    }

    var image = getArticleThumb(article, 'large');
    return React.createElement(ArticleComponent, _extends({
      article: article,
      source: source,
      image: image,
      vimeo: article.vimeoData
    }, props), source && (source.value.api === 'avdigitheme' || source.value.api === 'avtheme') && source.config.columns.additionalColumns.length > 0 && source.config.columns.additionalColumns.map(function (key) {
      return React.createElement(ArticleAdditionalColumnComponent, _extends({
        article: article,
        source: source,
        key: key,
        value: props[key]
      }, source.colObject[key]));
    }));
  };

  ArticleWindow.prototype.render = function render() {
    var _props3 = this.props,
        t = _props3.t,
        id = _props3.id,
        articleLoading = _props3.articleLoading,
        articles = _props3.articles,
        onClose = _props3.onClose,
        hideOpenExternalBtn = _props3.hideOpenExternalBtn,
        featureStyle = _props3.featureStyle,
        children = _props3.children,
        hideLayers = _props3.hideLayers;
    var article = articles[id];
    var source = article && getSource(article.id.split('_')[0]);
    return React.createElement('div', {
      className: ['article-window', articleLoading ? 'article-window--loading' : ''].join(' ')
    }, article && source && !hideLayers && React.createElement(VectorLayer, {
      key: 'articleView',
      layerName: source.dataIndex + '_articleView',
      selectable: false,
      features: article ? [article.olFeature] : [],
      featureStyle: featureStyle || getFeatureStyle(source)
    }), React.createElement('div', {
      className: 'buttonBar'
    }, article && !hideOpenExternalBtn && React.createElement(Button, {
      bsStyle: 'primary',
      className: 'linkBtn',
      href: article.properties.link,
      target: '_blank',
      title: t('OpenExternal')
    }, React.createElement(Glyphicon, {
      glyph: 'new-window'
    })), onClose && React.createElement(Button, {
      bsStyle: 'primary',
      className: 'closeBtn',
      onClick: onClose,
      title: t('Close')
    }, React.createElement(Glyphicon, {
      glyph: 'remove'
    }))), this.renderArticle(article, source), children);
  };

  return ArticleWindow;
}(React.Component);
ArticleWindow.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  setCenter: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  articles: PropTypes.object,
  articleId: PropTypes.string,
  articleLoading: PropTypes.bool.isRequired,
  articleError: PropTypes.bool.isRequired,
  loadArticle: PropTypes.func.isRequired,
  resetLoadState: PropTypes.func.isRequired,
  mapZoom: PropTypes.number,
  projCode: PropTypes.string,
  maxZoom: PropTypes.number,
  fitViewAndZoom: PropTypes.func,
  hideOpenExternalBtn: PropTypes.bool,
  articleComponent: PropTypes.func,
  additionalColumnComponent: PropTypes.func,
  children: PropTypes.node,
  featureStyle: PropTypes.object,
  hideLayers: PropTypes.bool
} : {};
ArticleWindow.defaultProps = {
  hideLayers: false
};
export default connect(mapStateToProps, mapDispatchToProps)(translate('ArticleWindow')(provideMapState(ensureArticleModuleConfig(ArticleWindow))));